import React from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import ProDetailContainer from '../components/pro/ProDetailContainer';
import { PRO_TAB_IDS } from './pro/components/Tabs';

/**
 * /order-details/:pronumber route — legacy alias for the Pro detail page.
 * Renders the same <ProDetailContainer mode="page"> as /pro/:pronumber
 * (ProPage); the old inline OrderDetailsDrawer page was retired along with
 * the legacy drawer. URL hash drives the active tab so deep links keep working.
 */
const OrderDetailsPage: React.FC = () => {
  const { pronumber } = useParams<{ pronumber: string }>();
  const location = useLocation();
  const navigate = useNavigate();

  const proNum = pronumber ? parseInt(pronumber, 10) : NaN;
  const hashId = location.hash.replace('#', '');
  const activeTab = PRO_TAB_IDS.has(hashId) ? hashId : 'order-info';
  const setActiveTab = (id: string) => navigate(`#${id}`, { replace: true });

  if (Number.isNaN(proNum)) {
    return <div className="p-4 text-red-600">Invalid PRO number.</div>;
  }

  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 min-h-0">
        <ProDetailContainer
          pronumber={proNum}
          mode="page"
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />
      </div>
    </div>
  );
};

export default OrderDetailsPage;
